import Vue from 'vue';
import Router from 'vue-router';
import ColourLogic from './views/ColourLogic.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => savedPosition || { x: 0, y: 0 },
  routes: [
    {
      path: '/',
      name: 'ColourLogic',
      component: ColourLogic,
    },
  ],
});
